document.addEventListener('DOMContentLoaded', () => {

  // Only proceed if on product page
  const isProductPage = document.querySelector('body.template-product, .product, [data-section-type="product"], [data-section-id*="product"]');
  if (!isProductPage) return;

  // Configuration: Fields that should sync with variants
  const SYNC_FIELDS = [
    'länge', 'breite', 'höhe', 'gewicht', 'material', 'durchmesser',
    'farbe', 'verschluss', 'beschreibung', 'details', 'lieferung',
    'legierung', 'zertifikat', 'schliff', 'steinanzahl', 'steinart',
    'beschichtung', 'herkunft'
  ];

  // Configuration: Field type mappings for smart extraction
  const FIELD_TYPES = {
    dimensions: ['länge', 'breite', 'höhe', 'durchmesser'],
    weight: ['gewicht'],
    text: ['material', 'farbe', 'verschluss', 'beschreibung', 'details', 'lieferung', 'legierung', 'zertifikat', 'schliff', 'steinanzahl', 'steinart', 'beschichtung', 'herkunft']
  };

  // Initialize variant synchronization
  setTimeout(() => {
    syncVariantFields();
    setupEventListeners();
  }, 500);

  function setupEventListeners() {
    // Listen to Shopify variant change events
    ['variant:changed', 'variant:change'].forEach(eventType => {
      document.addEventListener(eventType, (event) => {
        const variant = event.detail?.variant;
        if (variant) syncVariantFields(variant);
      });
    });

    // Listen to form changes
    document.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
      form.addEventListener('change', (event) => {
        if (['SELECT', 'INPUT'].includes(event.target.tagName)) {
          setTimeout(syncVariantFields, 100);
        }
      });
    });

    // Listen to variant selector changes
    document.querySelectorAll('select[name^="option-"], .variant-swatch__radio').forEach(selector => {
      selector.addEventListener('change', () => setTimeout(syncVariantFields, 100));
    });
  }

  function getCurrentVariant() {
    // Try multiple methods to get current variant
    const methods = [
      () => {
        const script = document.querySelector('script[data-variant]');
        return script ? JSON.parse(script.textContent) : null;
      },
      () => window.product?.selected_variant,
      () => {
        const input = document.querySelector('input[name="id"][data-product-select], input[name="id"][data-variant-id]');
        return input?.value ? { id: input.value } : null;
      }
    ];

    for (const method of methods) {
      try {
        const variant = method();
        if (variant) return variant;
      } catch (error) {
        // console.warn('Error getting variant:', error);
      }
    }
    return null;
  }

  function findMatchingField(labelText) {
    const normalizedLabel = labelText.toLowerCase().replace(/[äöü]/g, char => {
      const map = { 'ä': 'ae', 'ö': 'oe', 'ü': 'ue' };
      return map[char] || char;
    });

    return SYNC_FIELDS.find(field => {
      const normalizedField = field.toLowerCase().replace(/[äöü]/g, char => {
        const map = { 'ä': 'ae', 'ö': 'oe', 'ü': 'ue' };
        return map[char] || char;
      });
      
      return normalizedLabel.includes(normalizedField) || normalizedField.includes(normalizedLabel);
    });
  }

  function extractValueFromVariant(variant, fieldName) {
    // Priority 1: Variant metafields
    if (variant.metafields?.custom?.[fieldName]) {
      const metafield = variant.metafields.custom[fieldName];
      return { value: metafield.value || metafield, source: 'variant metafield' };
    }

    // Priority 2: Product metafields
    if (window.product?.metafields?.custom?.[fieldName]) {
      const metafield = window.product.metafields.custom[fieldName];
      return { value: metafield.value || metafield, source: 'product metafield' };
    }

    // Priority 3: Variant options
    if (variant.option_values) {
      const option = variant.option_values.find(opt => {
        if (!opt.name) return false;
        const optName = opt.name.toLowerCase();
        const field = fieldName.toLowerCase();
        return optName === field || optName.includes(field) || field.includes(optName);
      });
      if (option) return { value: option.value, source: 'variant option' };
    }

    // Priority 4: Extract from variant title based on field type
    if (variant.title) {
      return extractFromTitle(variant.title, fieldName);
    }

    return null;
  }

  function extractFromTitle(title, fieldName) {
    const parts = title.split(' / ');
    const fieldType = getFieldType(fieldName);

    switch (fieldType) {
      case 'dimensions':
        return extractDimensionFromTitle(parts, fieldName);
      case 'weight':
        return extractWeightFromTitle(parts);
      default:
        return extractTextFromTitle(parts, fieldName);
    }
  }

  function getFieldType(fieldName) {
    for (const [type, fields] of Object.entries(FIELD_TYPES)) {
      if (fields.includes(fieldName)) return type;
    }
    return 'text';
  }

  function extractDimensionFromTitle(parts, fieldName) {
    const measurements = parts.filter(part => /\d+\s*(cm|mm|m)\b/i.test(part));
    const fieldIndex = FIELD_TYPES.dimensions.indexOf(fieldName);
    
    if (measurements[fieldIndex]) {
      return { value: measurements[fieldIndex].trim(), source: `title (${fieldName})` };
    }

    // Fallback: look for explicit field name
    const explicitPart = parts.find(part => {
      const lower = part.toLowerCase();
      return lower.includes(fieldName) && /\d+/i.test(part);
    });
    
    return explicitPart ? { value: explicitPart.trim(), source: `title (${fieldName} explicit)` } : null;
  }

  function extractWeightFromTitle(parts) {
    const weightPart = parts.find(part => /\d+\s*(g|kg|gr|gram)\b/i.test(part));
    return weightPart ? { value: weightPart.trim(), source: 'title (weight)' } : null;
  }

  function extractTextFromTitle(parts, fieldName) {
    const textPart = parts.find(part => {
      const lower = part.toLowerCase();
      return lower.includes(fieldName) && !/^\d+\s*(cm|mm|m|g|kg)\b/i.test(part);
    });
    return textPart ? { value: textPart.trim(), source: `title (${fieldName})` } : null;
  }

  function updateTableCell(valueCell, newValue) {
    let valueSpan = valueCell.querySelector('.product-detail-table__variant-value');
    if (!valueSpan) {
      valueSpan = document.createElement('span');
      valueSpan.className = 'product-detail-table__variant-value';
      valueCell.innerHTML = '';
      valueCell.appendChild(valueSpan);
    }
    valueSpan.textContent = newValue;
  }

  function syncVariantFields(variant = null) {
    // console.log('🔄 Starting product detail table sync...');
    
    variant = variant || getCurrentVariant();
    if (!variant) {
      // console.log('❌ No variant found - sync aborted');
      return;
    }

    const detailTable = document.querySelector('.product-detail-table');
    if (!detailTable) {
      // console.log('❌ No product detail table found');
      return;
    }

    const rows = detailTable.querySelectorAll('.product-detail-table__row');
    let updatedCount = 0;

    rows.forEach((row, index) => {
      const label = row.querySelector('.product-detail-table__label');
      const valueCell = row.querySelector('.product-detail-table__value');
      
      if (!label || !valueCell) return;

      const labelText = label.textContent.trim();
      const matchingField = findMatchingField(labelText);
      
      if (!matchingField) {
        // console.log(`⏭️ Row ${index + 1}: No matching field for "${labelText}"`);
        return;
      }

      const result = extractValueFromVariant(variant, matchingField);
      if (!result) {
        // console.log(`⚠️ Row ${index + 1}: No value found for "${matchingField}"`);
        return;
      }

      const currentValue = valueCell.textContent.trim();
      const newValue = String(result.value).trim();
      
      if (currentValue !== newValue && currentValue !== '—') {
        // console.log(`🔄 Row ${index + 1}: Updating "${labelText}" from "${currentValue}" to "${newValue}" (${result.source})`);
        updateTableCell(valueCell, newValue);
        updatedCount++;
      } else {
        // console.log(`✅ Row ${index + 1}: Value "${currentValue}" already current`);
      }
    });

    // console.log(`🎉 Sync completed. ${updatedCount} fields updated.`);
  }
});
